import React, { useState, forwardRef } from 'react';
import axiosWrapper from '../../_utils/Axios';
import './ContactForm.scss';
import { sanitizeInput } from '../../_utils/Validation';

const ContactForm = forwardRef(function ContactForm(props,  contactRef){
    // 0: 서비스 도입 문의, 1: 검사 제휴 문의
    const [activeTab, setActiveTab] = useState(0);
    const [loading, setLoading] = useState(false);
    // "문의하기", "Thank you!"
    const [submitText, setSubmitText] = useState("문의하기");
    const [formValues, setFormValues] = useState({
        company: '',
        phone: '',
        email: '',
        message: '' 
    });

    const submitBtnClick = (e) => {
        if(loading) return;
        
        if(formValues.company === "") {
            alert('회사명을 입력해주세요.');
            return;
        } else if(formValues.phone === "") {
            alert('연락처를 입력해주세요.');
            return;
        } else if(formValues.email === "") {
            alert('이메일을 입력해주세요.');
            return;
        } else if(formValues.message === "") {
            alert('문의내용을 입력해주세요.');
            return;
        }

        // debouncing
        setLoading(true);

        const payload = {
            title : activeTab === 0 ? "서비스 도입 문의" : "검사 제휴 문의",
            companyNm : formValues.company,
            hpNo : formValues.phone,
            mail : formValues.email,
            content : formValues.message 
        };

        axiosWrapper('POST', 'hello/micro/mail/send', payload)
        .then((res) => {
            console.log('email send ok', res);

            if(res.status === 200) {
                alert("문의가 접수되었습니다.");
            } else {
                alert("시스템 오류입니다. status: ", res.status);
            }

            setLoading(false);
            setSubmitText("Thank you!");
            setTimeout(() => {
                setSubmitText("문의하기");
            }, 100);
        })
        .catch((error) => {
            console.log('call error', error);
            alert(error.message);
        });
    };

    return (
        <div ref={contactRef} className="contents-area" id="contact">
            <div className="contents-container">
                <div className="contents-section center">
                    <div className="contents-section-title">
                        <strong className="fc-black">CONTACT</strong>
                    </div>
                    <div className="tab-menu-container">
                        <ul className="tab-menu-list">
                            <li 
                                className={activeTab === 0 ? 'active' : ''}
                                onClick={() => setActiveTab(0)}
                            >
                                <span>서비스 도입 문의</span>
                            </li>
                            <li
                                className={activeTab === 1 ? 'active' : ''}
                                onClick={() => setActiveTab(1)}
                            >
                                <span>검사 제휴 문의</span>
                            </li>
                        </ul>
                    </div>
                    {[0, 1].map((tabIndex) => (
                        <div 
                            key={tabIndex}
                            className={`contact-tab-contents ${activeTab === tabIndex ? 'active' : ''}`}
                        >
                            <form>
                                <div className="contact-form">
                                    <div className="contact-infolist-area">
                                        <div className="flex-area half">
                                            <div className="contact-infolist-box">
                                                <div className="contact-info-label">
                                                    <span>
                                                        회사명
                                                    </span>
                                                </div>
                                                <div className="info-value-default">
                                                    <input 
                                                        type="text"
                                                        name="company"
                                                        placeholder="회사명을 입력해주세요."
                                                        value={formValues.company}
                                                        onChange={(e) => 
                                                            setFormValues({
                                                                ...formValues,
                                                                [e.target.name]: sanitizeInput(e.target.value)
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="contact-infolist-box">
                                                <div className="contact-info-label">
                                                    <span>
                                                        연락처
                                                    </span>
                                                </div>
                                                <div className="info-value-default">
                                                    <input
                                                        type="number"
                                                        name="phone"
                                                        placeholder="-없이 입력해주세요."
                                                        value={formValues.phone}
                                                        onChange={(e) => 
                                                            setFormValues({
                                                            ...formValues,
                                                            [e.target.name]: sanitizeInput(e.target.value)
                                                            })
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="contact-infolist-box">
                                            <div className="contact-info-label">
                                                <span>
                                                    이메일 주소
                                                </span>
                                            </div>
                                            <div className="info-value-default mb-8">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="이메일 주소를 입력해주세요."
                                                    value={formValues.email}
                                                    onChange={(e) => 
                                                        setFormValues({
                                                            ...formValues,
                                                            [e.target.name]: sanitizeInput(e.target.value)
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="contact-infolist-box">
                                            <div className="contact-info-label">
                                                <span>
                                                    문의 내용
                                                </span>
                                            </div>
                                            <div className="contact-info-memo">
                                            <textarea
                                                name="message"
                                                placeholder="문의 내용을 입력해주세요."
                                                value={formValues.message}
                                                onChange={(e) => 
                                                    setFormValues({
                                                      ...formValues,
                                                      [e.target.name]: sanitizeInput(e.target.value)
                                                    })
                                                }
                                            ></textarea>
                                            </div>
                                        </div>

                                        <div className="btn-container">
                                            <button
                                                type="button"
                                                className="btn-basic"
                                                onClick={submitBtnClick}
                                            >
                                                {loading ? (
                                                    <>
                                                        {<div className="spinner" />}
                                                    </>
                                                ):(
                                                    <>
                                                        <span className="inquireMessage" style={{ display: loading ? 'none' : 'inline' }}>
                                                            {submitText}
                                                        </span>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
});

export default ContactForm;
